/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PartnerDto } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    findSchool(codeParent: string, country: string, idSchool?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    findSchool(codeParent: string, country: string, idSchool?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    findSchool(codeParent: string, country: string, idSchool?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    findSchool(codeParent: string, country: string, idSchool?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/${codeParent}/${country}`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findSchool1(codeParent: string, country: string, idSchool?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    findSchool1(codeParent: string, country: string, idSchool?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    findSchool1(codeParent: string, country: string, idSchool?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    findSchool1(codeParent: string, country: string, idSchool?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/${codeParent}/${country}`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
